<template>
    <LayoutDashboard title="Estoques">     
        <v-card outlined>
            <v-card-title>
                <v-btn color="primary" @click="cadastrarEstoque" outlined v-if="$helper.verificaPermissao('cadastrar-estoque')">Cadastrar</v-btn>
                <v-spacer></v-spacer>
                <v-text-field outlined dense v-model="search" append-icon="search" label="Pesquisar" single-line hide-details>
                </v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="getEstoques" :search="search">
                    <template v-slot:item.action="{ item }">
                        <v-btn color="primary" outlined small @click="visualizarEstoque(item)" v-if="$helper.verificaPermissao('visualizar-estoque')">Visualizar</v-btn>
                    </template>
                    <template v-slot:item._principal="{ item }">
                        <span v-if="item.principal">(ESTOQUE PRINCIPAL)</span>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <ModalCadastro />
    </LayoutDashboard>
</template>
<script>
    import {mapActions, mapGetters} from "vuex"
    import ModalCadastro from '@/pages/estoque/ModalCadastro'
    export default { 
        components: {
            ModalCadastro
        },
        data() {
            return {
                search: '',
                headers: [
                    { text: '#', value: 'id', sortable: true },
                    { text: 'Nome', align: 'left', sortable: true, value: 'nome'},
                    { text: '', value: '_principal', sortable: false },
                    { text: 'Ações', value: 'action', sortable: false }
                ],
            }
        },
        computed: {
            ...mapGetters([
                'getEstoques'
            ])
        },
        methods: {
            ...mapActions([
                'listarEstoque',
                'cadastrarEstoque',
                'visualizarEstoque',
            ])
        },
        created(){
            this.listarEstoque()
        }
    }
</script>